import { Check, ChevronDown } from "lucide-react"
import { Button } from "@/components/ui/Button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/DropdownMenu"
import { currencyDisplay } from "@/lib/money"

interface Props {
  currencies: string[]
  value: string | null
  onChange: (currency: string) => void
}

/** "Show in" picker for the all-markets page: one entry per market currency. */
export default function CurrencyMenu({ currencies, value, onChange }: Props) {
  const label = (c: string) => `${c} ${currencyDisplay(c).symbol}`
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="h-auto gap-2 px-3 py-1.5 text-left focus-visible:ring-0 focus-visible:ring-offset-0"
        >
          <span className="text-xs font-semibold text-foreground">{value ? label(value) : "Currency"}</span>
          <ChevronDown className="h-3.5 w-3.5 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-[200px]">
        <DropdownMenuLabel className="text-xs">Show every market in</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {currencies.map((c) => (
          <DropdownMenuItem
            key={c}
            onSelect={() => onChange(c)}
            className="flex items-center justify-between text-xs"
            style={{ color: c === value ? "var(--primary)" : "var(--foreground)", fontWeight: c === value ? 600 : 400 }}
          >
            {label(c)}
            {c === value && <Check className="h-3.5 w-3.5 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
